import { Avatar, Space } from "antd";
import { Link } from "react-router-dom";
import EllipsisText from "components/EllipsisText";
import { EditOutlined } from "@ant-design/icons";

const columns = (workers_options = []) => [
  {
    title: "Pracownik",
    dataIndex: "user_id",
    sortable: true,
    searchable: true,
    search_method: "in",
    search_component: "select",
    options: workers_options,
    width: 300,
    render: (_, { id, user }) =>
      user?.id ? (
        <Space>
          <Avatar
            shape={user.type === "User::User" ? "square" : "circle"}
            style={{ backgroundColor: user?.color }}
          >
            {user?.initials}
          </Avatar>
          <Link to={`/notes/${id}`}>
            <EllipsisText text={user?.full_name} limit={20} />
          </Link>
          <EditOutlined />
        </Space>
      ) : (
        "-"
      ),
  },
  {
    title: "Treść",
    dataIndex: "content",
    sortable: true,
    searchable: true,
    search_method: "matches",
    render: (_, { content }) => (
      <EllipsisText text={content} limit={150} tooltip_limit={400} />
    ),
  },
];

export default columns;
